import { IconComponent } from '@backstage/core-plugin-api';
import { SidebarSubmenuItem } from '@backstage/core-components';

interface AllTeamsProps {
  icon: IconComponent;
}

export const AllTeams = ({ icon }: AllTeamsProps) => {
  return <SidebarSubmenuItem title="All teams" to="groups" icon={icon} key="all teams" />;
};
